import React, { useMemo } from "react";
import { useUsersUIContext } from "../UsersUIContext";

export function UsersGrouping() {
  // Users UI Context
  const UsersUIContext = useUsersUIContext();
  const UsersUIProps = useMemo(() => {
    return {
      ids: UsersUIContext.ids,
      setIds: UsersUIContext.setIds,
      openDeleteUsersDialog: UsersUIContext.openDeleteUsersDialog,
      openFetchUsersDialog: UsersUIContext.openFetchUsersDialog,
      openUpdateUsersStatusDialog: UsersUIContext.openUpdateUsersStatusDialog
    };
  }, [UsersUIContext]);

  return (
    <div className="form">
      <div className="row align-items-center form-group-actions margin-top-20 margin-bottom-20">
        <div className="col-xl-12">
          <div className="form-group form-group-inline">
            <div className="form-label form-label-no-wrap">
              <label className="font-bold font-danger">
                <span>
                  Selected records count: <b>{UsersUIProps.ids.length}</b>
                </span>
              </label>
            </div>
            <div>
              <button
                type="button"
                className="btn btn-danger font-weight-bolder font-size-sm"
                onClick={UsersUIProps.openDeleteUsersDialog}
              >
                <i className="fa fa-trash"></i> Delete All
              </button>
              &nbsp;
              <button
                type="button"
                className="btn btn-light-primary font-weight-bolder font-size-sm"
                onClick={UsersUIProps.openFetchUsersDialog}
              >
                <i className="fa fa-stream"></i> Fetch Selected
              </button>
              &nbsp;
              <button
                type="button"
                className="btn btn-light-primary font-weight-bolder font-size-sm"
                onClick={UsersUIProps.openUpdateUsersStatusDialog}
              >
                <i className="fa fa-sync-alt"></i> Update Status
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
